import { controls, currencyToNumber, grouped } from "../../controls";

const rp101o = {
  label: "Bank Financial Position",
  starting: true,
  url: "rp101m",
  pageLabel: "Bank Financial Position",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "lqe" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Monthly Financial Position",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    textReportProps: {
      'Recon': {
        filename: `Monthly Financial Position-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    pivotable: true,
    charts: {
      pie: {
        row: { targetfield: 'all_total', flabel: 'group_display' },
        column: { targetrow: 'grand_total' },
      }
    },
    extraRows: {
      location: "bottom",
      fields: ["amount"],
      subtotals: {
        by: "parent",
        displayIn: "group_display",
        labels: {
          share: "Share Total", type2: "Total", type3: "Total"
        },
      },
      grandtotal: { type: "fixed", displayIn: "group_display", val: "Grand Total", count: true },
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Particulars",
        accessor: "group_display",
        rwidth: "*"
      },
      {
        Header: "Amount",
        accessor: "amount",
        type: "currency",
        fontSize: (d) => (d['group_display'] == 'Branch Adjustment' && currencyToNumber(d['amount']) > 300000) ? 10 : 8,
        color: (d) => (d['group_display'] == 'Branch Adjustment' && currencyToNumber(d['amount']) > 300000) ? "white" : "black",//green 
        back: (d) => (d['group_display'] == 'Branch Adjustment' && currencyToNumber(d['amount']) > 300000) ? "gray" : "white",//green 
      }
    ]
  }
};

export default rp101o;